import React from 'react';

import { useFilters } from '../hooks/useFilters';
import { useScrollToSelectedElement } from '../hooks/useScrollToSelectedElement';

import Filters from './Filters';
import VideoCard from './VideoCard';
import Section from './Section';

export default function VideoCards({ section }) {
  const { references } = section;
  const { selectedElement, setSelectedElement } = useFilters(references);

  const buttons = section?.blockContent?.buttons;

  useScrollToSelectedElement(selectedElement);

  return (
    <>
      {references && (
        <div className="video-cards">
          <Section
            section={{
              ...section,
              blockContent: { ...section.blockContent, buttons: [] },
              version: 'regular',
              backgroundColor: ''
            }}
          />
          <div className="video-cards__filters">
            <Filters
              filters={references}
              handleClick={setSelectedElement}
              selectedElement={selectedElement}
            />
          </div>
          <div className="video-cards__selected-card">
            <VideoCard
              section={{
                ...selectedElement,
                blockContent: { ...section.blockContent, buttons: buttons }
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
